<script setup>
defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
  noRecordsFound: {
    type: Boolean,
    default: false,
  },
  loadingMessage: {
    type: String,
    default: '',
  },
  noRecordsMessage: {
    type: String,
    default: '',
  },
  // ADITIVO: sem valor, nada muda — as outras 25 telas que usam este layout
  // continuam com o painel de ponta a ponta. Existe porque uma tela larga
  // deixava o painel esticado e o conteudo ilhado no meio dele, e limitar o
  // conteudo POR DENTRO so movia o vazio para as bordas do proprio painel.
  // Quem tem tabela estreita limita o painel; quem nao passa nada nao ve
  // diferenca nenhuma.
  bodyClass: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div class="flex flex-col w-full h-full gap-4 font-inter">
    <slot name="header" />
    <!-- Added to render any templates that should be rendered before body -->
    <!-- The panel border already encloses the body, so a table head must not draw
         a second rule right under it. -->
    <main
      class="px-4 py-2 border rounded-pz border-n-weak bg-n-card shadow-pz [&_thead]:border-t-0"
      :class="bodyClass"
    >
      <slot name="preBody" />
      <slot v-if="isLoading" name="loading">
        <woot-loading-state :message="loadingMessage" />
      </slot>
      <p
        v-else-if="noRecordsFound"
        class="flex-1 py-20 text-n-slate-12 flex items-center justify-center text-base"
      >
        {{ noRecordsMessage }}
      </p>
      <slot v-else name="body" />
      <!-- Do not delete the slot below. It is required to render anything that is not defined in the above slots. -->
      <slot />
    </main>
  </div>
</template>
